var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNfE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.627,
    height: 17.282,
    viewBox: "0 0 17.627 17.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nf-e",
    transform: "translate(-39.02 -28.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3061",
    "data-name": "Grupo 3061",
    transform: "translate(39.02 28.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2326",
    "data-name": "Caminho 2326",
    d: "M49.714,45.672H41.287A2.27,2.27,0,0,1,39.02,43.4V30.657a2.27,2.27,0,0,1,2.267-2.267h8.427a2.27,2.27,0,0,1,2.267,2.267V32.35a.359.359,0,1,1-.717,0V30.657a1.552,1.552,0,0,0-1.55-1.55H41.287a1.551,1.551,0,0,0-1.55,1.55V43.4a1.551,1.551,0,0,0,1.55,1.55h8.427a1.552,1.552,0,0,0,1.55-1.55V41.856a.359.359,0,1,1,.717,0V43.4A2.27,2.27,0,0,1,49.714,45.672Z",
    transform: "translate(-39.02 -28.39)",
    fill: "#64c2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3062",
    "data-name": "Grupo 3062",
    transform: "translate(42.047 34.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2327",
    "data-name": "Caminho 2327",
    d: "M202.647,347.467h-1.312l-2.117-3.682h-.03q.063.976.063,1.392v2.29h-.922V342.6h1.3l2.114,3.645h.023q-.05-.949-.05-1.342v-2.3h.929Z",
    transform: "translate(-198.33 -342.6)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2328",
    "data-name": "Caminho 2328",
    d: "M491.065,347.467H490.05V342.6h2.79v.845h-1.774V344.7h1.651v.842h-1.651Z",
    transform: "translate(-484.507 -342.6)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2329",
    "data-name": "Caminho 2329",
    d: "M665.42,481.5v-.832h1.788v.832Z",
    transform: "translate(-656.545 -478.047)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2330",
    "data-name": "Caminho 2330",
    d: "M788.221,403.038a1.92,1.92,0,0,1-1.4-.5,1.877,1.877,0,0,1-.506-1.4,2.066,2.066,0,0,1,.468-1.446,1.666,1.666,0,0,1,1.294-.511,1.639,1.639,0,0,1,1.228.449,1.7,1.7,0,0,1,.439,1.242v.493h-2.4a.978.978,0,0,0,.256.676.9.9,0,0,0,.673.243,2.8,2.8,0,0,0,.636-.07,3.184,3.184,0,0,0,.626-.223v.786a2.385,2.385,0,0,1-.569.2A3.56,3.56,0,0,1,788.221,403.038Zm-.143-3.136a.643.643,0,0,0-.506.2.947.947,0,0,0-.21.581h1.425a.847.847,0,0,0-.2-.581A.665.665,0,0,0,788.077,399.9Z",
    transform: "translate(-775.139 -398.105)",
    fill: "#64c2c8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfE);
export default __webpack_public_path__ + "static/media/nfE.4b7dabdc46d62a22327b5a5afde93295.svg";
export { ForwardRef as ReactComponent };